module.exports = __webpack_public_path__ + "static/media/06_05_2025_Region_20_Executive_Committee_Minutes.cfe33676.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/25-26/06_05_2025_Region_20_Executive_Committee_Minutes.pdf
// module id = 242
// module chunks = 0